<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Recuperated Energy during Driving"  chart.
    </rb-callout>
</div>
<div id="regenerative-charging"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Retained energy by regenerative braking in the last {{numberMonths}} month.
    </div>
</div>